import React from "react";
import RoleHierarchyTree from "./components/RoleHierarchyTree";

export default function RoleFeature() {
  return <RoleHierarchyTree />;
}
